export default class StatusMessage {
    constructor(props={}) {
        this.Status = props.Status || null;
        this.Message = props.Message || null;
    }
}
